import { render, staticRenderFns } from "./BxBtn.vue?vue&type=template&id=54cb7cd1&"
import script from "./BxBtn.vue?vue&type=script&lang=js&"
export * from "./BxBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports